module.exports = __webpack_public_path__ + "img/1.c30a1644.png";